module.exports = __webpack_public_path__ + "img/ltkfindsunder100-3x.afc92d7.jpg";